let environment = "production";

export const URL = environment === "production" ? "https://www.gruponacionalec.mx:50100/api" : 'http://localhost:50100/api'; // http://localhost:50100/api
export const IMG = "/assets/img/logoGNAC.png"
